import { z } from "zod";
import { isValidCPF } from "@/utils/validators";

const invalidCharsRegex = /^[.\s]+$/;
const repeatedCharsRegex = /^(.)\1+$/;
const validNameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.(com|com\.br|br)$/i;

export const newUserSchema = z.object({
	name: z
		.string()
		.min(3, "*Nome muito curto")
		.max(50, "*Nome muito longo")
		.refine((value) => {
			const trimmed = value.trim();

			if (invalidCharsRegex.test(trimmed)) {
				return false;
			}

			if (repeatedCharsRegex.test(trimmed.replace(/\s+/g, ""))) {
				return false;
			}

			if (!validNameRegex.test(trimmed)) {
				return false;
			}

			return true;
		}, "*Preencha corretamente"),

	cpf: z
		.string()
		.max(14, "*CPF inválido")
		.refine((value) => (value ? isValidCPF(value) : false), "*CPF inválido")
		.nonempty(
			"*Adicione o CPF verdadeiro do usuário. É a identificação única de cada usuário no sistema"
		),

	email: z
		.string()
		.min(5, "*E-mail muito curto")
		.max(254, "*E-mail muito longo")
		.email("E-mail inválido")
		.refine(
			(value) => emailRegex.test(value),
			"O e-mail deve conter @ e terminar com .com, .com.br ou .br"
		),

	role: z.string().nonempty("*Obrigatório"),

	group_ids: z.array(z.number()).optional(),
});

export type NewUserFormValues = z.infer<typeof newUserSchema>;
